<template>
<v-layout row wrap>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Users</div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="userId" :loading="loading" :no-data-text="noDataText">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td>{{ props.item.usrRefId }}</td>
          <td class="text-xs-right">{{ props.item.firstName }}</td>
          <td class="text-xs-right">{{ props.item.lastName }}</td>
          <td class="text-xs-right">{{ props.item.email }}</td>
          <td class="text-xs-right">{{ formatBoolean(props.item.acctDisabled) }}</td>
          <td class="text-xs-right">{{ formatDate(props.item.createdDate) }}</td>
          <td class="text-xs-right" v-if="checkAccess(['userQuery'])">
            <table-action :rowData="props" query @query="doQuery"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
// import clone from 'clone'
import toDate from 'date-fns/toDate'
import { mapGetters } from 'vuex'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Ref ID', align: 'left', value: 'usrRefId' },
        { text: 'First Name', align: 'right', value: 'firstName' },
        { text: 'last Name', align: 'right', value: 'lastName' },
        { text: 'Email', align: 'right', value: 'email' },
        { text: 'Acct Disabled', align: 'right', value: 'acctDisabled', sortable: false },
        { text: 'Created Date', align: 'right', value: 'createdDate', sortable: false }
      ],
      filters: {
        usrRefId: null,
        id: null,
        firstName: null,
        lastName: null,
        email: null,
        mobileNo: null,
        officeNo: null,
        intermediary: null
      },
      totalItems: 0
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true
        const apiURI = this.$store.state.adminInter.intermediary.menu.InterUsers
        const { page, rowsPerPage } = this.pagination
        let expand = {
          inter: this.inter,
          page: page - 1,
          size: rowsPerPage
        }
        const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
        if (result.data) {
          this.totalItems = result.data.totalElements
          const { data } = result.data
          if (data) {
            // Format the data here
            this.items = []
            data.map((user) => {
              const convertUser = {
                id: user.userId,
                usrRefId: user.usrRefId,
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
                acctDisabled: user.acctDisabled,
                intermediary: user.intermediaryName,
                createdDate: toDate(user.createdDate)
              }
              this.items.push(convertUser)
            })
          }
        }
        this.loading = false
      } catch (err) {
        throw err
      }
    },
    doQuery(data) {
      if (data && data.item && data.item.id) {
        this.$router.push({ name: 'userQuery', params: { id: data.item.id } })
      }
    }
  },
  created() {
    if (this.checkAccess(['userReview', 'userQuery'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData(true)
  },
  props: {
    inter: String,
    menu: Object
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
